import React, { Component } from 'react';
import Modal from 'react-modal';
import { FormattedMessage } from 'ui/i18n';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { hasRefreshed } from 'utils/broadcast-refresh';
import { IMPERSONATION_EXPIRED } from 'config/api';

@observer
export default class ImpersonationExpiredModal extends Component {
	@observable isOpen = hasRefreshed(IMPERSONATION_EXPIRED);

	@action.bound
	handleClose() {
		this.isOpen = false;
	}

	render() {
		return (
			<Modal
				isOpen={this.isOpen}
				overlayClassName="ReactModal__Overlay"
				className="ReactModal__Content ImpersonationModal"
				onRequestClose={this.handleClose}
				contentLabel="Search for Franchisee or Company Store"
			>
				<h1>
					<FormattedMessage id="impersonation.expiredTitle" />
				</h1>
				<hr />
				<label className="user-search-label">
					<FormattedMessage id="impersonation.expiredText" />
				</label>

				<div className="Modal__Controls">
					<button
						className="btn btn-primary pull-right"
						onClick={this.handleClose}
					>
						<FormattedMessage id="ok.Button" />
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Impersonation/ExpiredModal.js